import { type NavigationAdapter } from './NavigationAdapter';

export const realNavigation: NavigationAdapter = {
  getCurrentUrl: () => new URL(window.location.href),
  getHistoryState: () => window.history.state,
  assign: (url) => window.location.assign(url),
  back: () => window.history.back(),
  pushState: (state, path) => window.history.pushState(state, '', path),
  replaceState: (state, path) => window.history.replaceState(state, '', path),
  onPopState: (handler) => {
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  },
};
